import React from 'react';

export function AtualizacaoPerfil({ modalData }) {
  return (
    <div>
      {modalData?.responsavel?.nomeFantasia ? (
        <span>
          <b>Instituição: </b> {modalData?.responsavel?.nomeFantasia}
        </span>
      ) : (
        ''
      )}

      {modalData?.responsavel?.email ? (
        <span>
          <b>, Responsável: </b> {modalData?.responsavel?.email}
        </span>
      ) : (
        ''
      )}
    </div>
  );
}
